import { convertPotentialStringToNumber } from "./number";
import { showMessageModal } from "../redux/actions";
import store from "../redux/store";

export const ensureBoolean = (
  value: any,
  whiteList = [],
  defaultValue: boolean | null | undefined = undefined
): boolean => {
  if (typeof value === "boolean" || whiteList.includes(value)) {
    return value;
  }

  return defaultValue;
};

export const ensureNumber = (
  value: any,
  whiteList = [],
  defaultValue: number | null | undefined = undefined
): number => {
  if (typeof value === "number" || whiteList.includes(value)) {
    return value;
  }

  const convertedValue = convertPotentialStringToNumber(value);

  return convertedValue ?? defaultValue;
};

export const ensureInteger = (
  value: any,
  whiteList = [],
  defaultValue: number | null | undefined = undefined
): number => {
  if (typeof value === "number") {
    return parseInt(value.toString());
  }
  if (whiteList.includes(value)) {
    return value;
  }

  return defaultValue;
};

export const ensureString = (
  value: any,
  allowEmpty = true,
  whiteList = [],
  defaultValue: string | null | undefined = undefined
): string => {
  if (
    (typeof value === "string" && (allowEmpty || value !== "")) ||
    whiteList.includes(value)
  ) {
    return value;
  }

  return defaultValue;
};

export const ensureStringOrNumber = (
  value: any,
  allowEmpty = true,
  whiteList = [],
  defaultValue: string | null | undefined = undefined
) => {
  if (
    (typeof value === "string" && (allowEmpty || value !== "")) ||
    typeof value === "number" ||
    whiteList.includes(value)
  ) {
    return value;
  }

  return defaultValue;
};

export const delay = async (ms: number): Promise<any> =>
  await new Promise((resolve: any) => setTimeout(() => resolve(), ms));

export type MessageModalOptions = {
  buttonName?: string;
  buttonCancelName?: string;
  subTitle?: string;
  primaryColor?: string;
  title?: string;
  text?: string;
  image?: string | null;
  withImage?: boolean;
  onClick?: () => void;
  hours?: unknown;
  showCancel?: boolean;
  activationRange?: boolean;
};

export const openMessageModal = (
  msg: string,
  options: MessageModalOptions = {}
) => {
  const {
    buttonName = "D'accord",
    buttonCancelName,
    subTitle = msg,
    primaryColor = "tertiary",
    title,
    text,
    image,
    withImage,
    onClick,
    ...restOptions
  } = options;

  store.dispatch(
    showMessageModal(msg, {
      onClick: () => {
        store.dispatch(showMessageModal(null));
        onClick?.();
      },
      buttonName,
      buttonCancelName,
      subTitle,
      primaryColor,
      title,
      text,
      image,
      withImage,
      ...restOptions,
    })
  );
};